import { 
    SET_VENDOR_EMAIL_HISTORY, 
    SET_VENDOR_EMAIL_HISTORY_MESSAGE 
} from './FleetPOVendorEmailHistoryType'

const initialState = {
    fleetVendorEmailHistory: [],
    fleetVendorEmailHistoryMessage : {}
}

const reducer = (state = initialState, action: any) => {
    if (action.type === SET_VENDOR_EMAIL_HISTORY) {
        return {
            ...state,
            fleetVendorEmailHistory: action.fleetVendorEmailHistory
        }
    }
    else if (action.type === SET_VENDOR_EMAIL_HISTORY_MESSAGE) {
        return {
            ...state,
            fleetVendorEmailHistoryMessage: action.message
        }
    }
    else {
        return state;
    }
}

export default reducer;